export type SubjectResponse = {
  data: { options: Array<Subject> };
};

export type Subject = {
  key: string;
  label: string;
  value: string;
  order: number;
};

export class SubjectModel {
  private subject: Subject;

  constructor(subject: Subject) {
    this.subject = subject;
  }

  get key() {
    return this.subject?.key || "";
  }

  get label() {
    return this.subject?.label || "";
  }

  get value() {
    return this.subject?.value || "";
  }

  get order() {
    return this.subject?.order || "";
  }
}
